import { render, staticRenderFns } from "./myOrganisationMembers.vue?vue&type=template&id=48d104e0&"
import script from "./myOrganisationMembers.vue?vue&type=script&lang=js&"
export * from "./myOrganisationMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports